import { render, staticRenderFns } from "./MaterialBoxLabelModal.vue?vue&type=template&id=fe902934&scoped=true&"
import script from "./MaterialBoxLabelModal.vue?vue&type=script&lang=js&"
export * from "./MaterialBoxLabelModal.vue?vue&type=script&lang=js&"
import style0 from "./MaterialBoxLabelModal.vue?vue&type=style&index=0&id=fe902934&prod&lang=scss&scoped=true&"
import style1 from "./MaterialBoxLabelModal.vue?vue&type=style&index=1&id=fe902934&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe902934",
  null
  
)

export default component.exports